import type { TableProps } from 'antd';
 export interface DataType {
  id: string;
  key: string;
  userMobile: string;
  activityName: string;
  productName: string;
  collectionAccount: number;
  collectionTime: string;
}

export const column = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '手机号',
    dataIndex: 'userMobile',
    key: 'userMobile',
  },
  {
    title: '权益包',
    dataIndex: 'activityName',
    key: 'activityName',
  },
  {
    title: '供货渠道',
    dataIndex: 'supplyChannelName',
    key: 'supplyChannelName',
  },
  {
    title: '权益',
    dataIndex: 'productName',
    key: 'productName',
  },
  {
    title: '领取账号',
    dataIndex: 'collectionAccount',
    key: 'collectionAccount',
  },
  {
    title: '领取类型',
    dataIndex: 'collectionType',
    key: 'collectionType',  
  }
];